import { NgModule, ModuleWithProviders } from '@angular/core';

import { FishAccordionModule, FishPanelChangeEvent } from './accordion/accordion.module';
import { FishAlertModule } from './alert/alert.module';
import { FishButtonsModule } from './buttons/radio.module';
import { FishCarouselModule } from './carousel/carousel.module';
import { FishCollapseModule } from './collapse/collapse.module';
import { FishDatepickerModule } from './datepicker/datepicker.module';
import { FishDropdownModule } from './dropdown/dropdown.module';
import { FishModalModule, FishModal, FishModalOptions, FishModalRef, ModalDismissReasons } from './modal/modal.module';
import { FishPaginationModule } from './pagination/pagination.module';
import { FishPopoverModule } from './popover/popover.module';
import { FishProgressbarModule } from './progressbar/progressbar.module';
import { FishRatingModule } from './rating/rating.module';
import { FishTabsetModule, FishTabChangeEvent } from './tabset/tabset.module';
import { FishTimepickerModule } from './timepicker/timepicker.module';
import { FishTooltipModule } from './tooltip/tooltip.module';
import { FishTypeaheadModule, FishTypeaheadSelectItemEvent } from './typeahead/typeahead.module';

export {
    FishAccordionModule,
    FishPanelChangeEvent,
    FishAccordionConfig,
    FishAccordion,
    FishPanel,
    FishPanelTitle,
    FishPanelContent
} from './accordion/accordion.module';
export { FishAlertModule, FishAlertConfig, FishAlert } from './alert/alert.module';
export { FishButtonsModule, FishRadioGroup } from './buttons/radio.module';
export { FishCarouselModule, FishCarouselConfig, FishCarousel, FishSlide } from './carousel/carousel.module';
export { FishCollapseModule, FishCollapse } from './collapse/collapse.module';
export {
    FishCalendar,
    FishCalendarIslamicCivil,
    FishDatepickerModule,
    FishDatepickerI18n,
    FishDatepickerConfig,
    FishDateStruct,
    FishDateParserFormatter,
    FishDatepicker,
    FishInputDatepicker
} from './datepicker/datepicker.module';
export { FishDropdownModule, FishDropdownConfig, FishDropdown } from './dropdown/dropdown.module';
export {
    FishModalModule,
    FishModal,
    FishModalOptions,
    FishActiveModal,
    FishModalRef,
    ModalDismissReasons
} from './modal/modal.module';
export { FishPaginationModule, FishPaginationConfig, FishPagination } from './pagination/pagination.module';
export { FishPopoverModule, FishPopoverConfig, FishPopover } from './popover/popover.module';
export { FishProgressbarModule, FishProgressbarConfig, FishProgressbar } from './progressbar/progressbar.module';
export { FishRatingModule, FishRatingConfig, FishRating } from './rating/rating.module';
export {
    FishTabsetModule,
    FishTabChangeEvent,
    FishTabsetConfig,
    FishTabset,
    FishTab,
    FishTabContent,
    FishTabTitle
} from './tabset/tabset.module';
export { FishTimepickerModule, FishTimepickerConfig, FishTimeStruct, FishTimepicker } from './timepicker/timepicker.module';
export { FishTooltipModule, FishTooltipConfig, FishTooltip } from './tooltip/tooltip.module';
export {
    FishHighlight,
    FishTypeaheadModule,
    FishTypeaheadConfig,
    FishTypeaheadSelectItemEvent,
    FishTypeahead
} from './typeahead/typeahead.module';

const FISH_MODULES = [
    FishAccordionModule, FishAlertModule, FishButtonsModule, FishCarouselModule, FishCollapseModule, FishDatepickerModule,
    FishDropdownModule, FishModalModule, FishPaginationModule, FishPopoverModule, FishProgressbarModule, FishRatingModule,
    FishTabsetModule, FishTimepickerModule, FishTooltipModule, FishTypeaheadModule
];


export class FishRootModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        FishAlertModule.forRoot(), FishButtonsModule.forRoot(), FishCollapseModule.forRoot(), FishProgressbarModule.forRoot(),
        FishTooltipModule.forRoot(), FishTypeaheadModule.forRoot(), FishAccordionModule.forRoot(), FishCarouselModule.forRoot(),
        FishDatepickerModule.forRoot(), FishDropdownModule.forRoot(), FishModalModule.forRoot(), FishPaginationModule.forRoot(),
        FishPopoverModule.forRoot(), FishProgressbarModule.forRoot(), FishRatingModule.forRoot(), FishTabsetModule.forRoot(),
        FishTimepickerModule.forRoot(), FishTooltipModule.forRoot()
    ],
    exports: FISH_MODULES
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class FishModule {
    static forRoot(): ModuleWithProviders { return { ngModule: FishRootModule }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{ imports: FISH_MODULES, exports: FISH_MODULES }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
